import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./index"
import { Button } from  "../buttons/button"
import { useTranslation } from 'react-i18next'

export function DeleteConfirmationAlert({category, item, onContinue, label, showLabel=false}) {
  const style = "w-7 h-7  text-danger hover:bg-danger/80 hover:text-white rounded-md p-2"
  const { t } = useTranslation("main")

  const confirmationLabels={
    // "server": "server? By confirming, the server will be removed from this plant",
    // "device": "device? By confirming, the device will be removed from this plant",
    // "widget": "? By confirming, the widget will be removed from this dashboard",
    "server": `${t('confirm.server_confirmation')}`,
    "device": `${t('confirm.device_confirmation')}`,
    "widget": `${t('confirm.widget_confirmation')}`,
  }
  const { icon, variant, continueVariant, title, continueLabel, description, continueIcon } = {
      icon: <i className={`ri-delete-bin-line rounded-md p-2  ${showLabel?"text-white":"text-danger hover:bg-danger/80 hover:text-white bg-danger/5"}`}></i>,
      variant: "danger",
      continueVariant: "danger",
      title: t('confirm.confirm_message'),
      continueLabel: t('confirm.delete_button'),
      description: (
        <p>
          {t('confirm.delete_confirmation')}
          <span className="pr-1 italic font-semibold">{item?.name}</span>
          {confirmationLabels[category]?? t('confirm.confirm_label') }
        </p>
      ),
      continueIcon: <i className={"ri-delete-bin-line text-white rounded-md p-2 bg-danger/5"}></i>,
  };
  

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        {showLabel ?
          <Button variant={variant} size="sm" className="w-full text-white hover:text-white group" >{icon}{label}</Button>:
          <button className=" hover:text-white group" >{icon}</button>
        }
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('confirm.cancel')}</AlertDialogCancel>
          <AlertDialogAction variant={continueVariant} onClick={()=>onContinue()}>{continueIcon} {continueLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
